import type { Plugin } from 'chart.js';

export const chartFramePlugin: Plugin = {
  id: 'chartFramePlugin',
  beforeDraw: (chart: any, _args: any, opts: { enabled?: boolean }) => {
    if (opts.enabled === false) return;
    const { ctx, width, height } = chart;
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = '#f4f7f9';
    ctx.fillRect(0, 0, width, height);
    ctx.restore();
  },
};
